<div class="flex h-full w-full flex-col">
  <div class="closeDiv flex flex-none basis-[50px] flex-row items-center justify-end">
    <ion-button class="close" fill="clear" shape="round" (click)="closeDialog()">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </div>
  <div class="dialog-content flex flex-1 flex-col pb-20 pt-0">
    <div class="flex flex-1 flex-wrap lg:gap-10">
      <div class="flex flex-1 flex-col justify-start">
        <h2>¡Ey, espera!</h2>
        <div class="description">
          <p *ngIf="quantityToFreeShipping > 0">
            Añade
            <span class="red-text">{{ quantityToFreeShipping | currency: cartService.cart.shipping.price.cur }}</span>
            para ahorrar los
            <strong>{{ getShippingPrice() | currency: cartService.cart.shipping.price.cur }}</strong> del envío
            estándar.
          </p>
          <div *ngIf="quantityToFreeShipping <= 0" class="freeShippingAchievedDiv">
            <div>
              <p>¡Genial! Vas a ahorrarte el envío estándar.</p>
            </div>
          </div>
          <app-product-list
            [limit]="15"
            [measurement]="true"
            [relatedProduct]="storeProductsInCart"
            [lateralList]="true"
          ></app-product-list>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap items-center justify-end gap-[10px] pl-20 pr-20 pt-10">
      <ion-button
        *ngIf="quantityToFreeShipping > 0"
        class="flex-1"
        fill="outline"
        expand="block"
        (click)="closeDialog()"
        color="danger"
      >
        No, quizás en otro momento
      </ion-button>
      <ion-button
        *ngIf="quantityToFreeShipping <= 0"
        class="flex-1"
        fill="outline"
        expand="block"
        color="success"
        (click)="closeDialog()"
      >
        Continuar con la compra
      </ion-button>
      <ion-button class="flex-1" fill="outline" expand="block" (click)="goToStore()"> Ver tienda completa </ion-button>
    </div>
  </div>
</div>
